import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export const AnnouncementIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25.8333 10.6667V15M13.1042 7.95836H9.36666C7.54648 7.95836 6.6364 7.95836
            5.94119 8.31259C5.32966 8.62418 4.83247 9.12136 4.52088 9.73289C4.16665 10.4281
            4.16666 11.3382 4.16666 13.1584L4.16666 14.4584C4.16666 15.4679 4.16666 15.9727
            4.33159 16.3708C4.55149 16.9017 4.97328 17.3235 5.50418 17.5434C5.90235 17.7084
            6.40712 17.7084 7.41666 17.7084V22.3125C7.41666 22.564 7.41666 22.6898 7.42709
            22.7957C7.52841 23.8244 8.34227 24.6383 9.37096 24.7396C9.47688 24.75 9.60264
            24.75 9.85416 24.75C10.1057 24.75 10.2314 24.75 10.3374 24.7396C11.366 24.6383
            12.1799 23.8244 12.2812 22.7957C12.2917 22.6898 12.2917 22.564 12.2917 22.3125V17.7084H13.1042C15.0178
            17.7084 17.3587 18.7342 19.1646 19.7186C20.2182 20.293 20.745 20.5801 21.09 20.5379C21.41 20.4987
            21.6519 20.355 21.8394 20.0929C22.0417 19.8102 22.0417 19.2445 22.0417 18.1132V7.5535C22.0417
            6.42219 22.0417 5.85653 21.8394 5.57382C21.6519 5.31167 21.41 5.16802 21.09 5.12883C20.745 5.08657
            20.2182 5.37374 19.1646 5.94808C17.3587 6.93256 15.0178 7.95836 13.1042 7.95836Z"
            stroke="currentColor" strokeWidth="2.16667" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        </SvgIcon>
    )
}

export const CanceledAttendancesIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.75 18.2501H18.25M24.75 10.6667H5.25M19.3333 4.16675V7.41675M10.6667
            4.16675V7.41675M10.45 25.8334H19.55C21.3702 25.8334 22.2803 25.8334 22.9755 25.4792C23.587
            25.1676 24.0842 24.6704 24.3958 24.0589C24.75 23.3637 24.75 22.4536 24.75 20.6334V11.5334C24.75
            9.71324 24.75 8.80316 24.3958 8.10795C24.0842 7.49642 23.587 6.99923 22.9755 6.68764C22.2803
            6.33341 21.3702 6.33341 19.55 6.33341H10.45C8.62983 6.33341 7.71974 6.33341 7.02453
            6.68764C6.413 6.99923 5.91582 7.49642 5.60423 8.10795C5.25 8.80316 5.25 9.71324 5.25
            11.5334V20.6334C5.25 22.4536 5.25 23.3637 5.60423 24.0589C5.91582 24.6704 6.413 25.1676
            7.02453 25.4792C7.71974 25.8334 8.62983 25.8334 10.45 25.8334Z"
            stroke="currentColor"
            strokeWidth="2.16667" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        </SvgIcon>
    )
}

export const DeletedInvestigationsIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.3333 4.16675V6.33341H18.25V9.84666C18.25 11.1012 18.5219 12.3394 19.0473
            13.478L23.6861 23.527C24.0621 24.3427 23.7056 25.308 22.891 25.6828C22.6776 25.7825
            22.4457 25.8334 22.2106 25.8334H7.78931C6.89231 25.8334 6.16431 25.1054 6.16431
            24.2084C6.16431 23.9733 6.21522 23.7404 6.31381 23.527L10.9526 13.478C11.4781 12.3405
            11.75 11.1012 11.75 9.84666V6.33341H10.6666V4.16675H19.3333ZM16.5036 12.8345H13.4963C13.3836
            13.2277 13.2471 13.6156 13.0911 13.9947L12.92 14.3858L8.63539 23.6667H21.3635L17.08
            14.3858C16.8481 13.8832 16.6553 13.3642 16.5036 12.8345ZM13.9166 9.84666C13.9166 10.1207
            13.9058 10.3948 13.8852 10.6678H16.1147C16.1039 10.5367 16.0974 10.4057 16.092 10.2735L16.0833
            9.84666V6.33341H13.9166V9.84666Z" fill="currentColor"/>
        </SvgIcon>
    )
}

export const DictionariesIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.0833 24.7501V27.4584L12.8333 25.2917L9.58333 27.4584V24.7501H9.04167C8.03605
            24.7501 7.07163 24.3506 6.36055 23.6395C5.64948 22.9285 5.25 21.964 5.25 20.9584V7.41675C5.25
            6.55479 5.59241 5.72814 6.2019 5.11865C6.8114 4.50916 7.63805 4.16675 8.5 4.16675H23.6667C23.954
            4.16675 24.2295 4.28088 24.4327 4.48405C24.6359 4.68721 24.75 4.96276 24.75 5.25008V23.6667C24.75
            23.9541 24.6359 24.2296 24.4327 24.4328C24.2295 24.6359 23.954 24.7501 23.6667 24.7501H16.0833ZM16.0833
            22.5834H22.5833V19.3334H9.04167C8.61069 19.3334 8.19736 19.5046 7.89262 19.8094C7.58787 20.1141
            7.41667 20.5274 7.41667 20.9584C7.41667 21.3894 7.58787 21.8027 7.89262 22.1075C8.19736 22.4122
            8.61069 22.5834 9.04167 22.5834H9.58333V20.4167H16.0833V22.5834ZM22.5833
            17.1667V6.33341H8.5V17.2047C8.67943 17.1792 8.86044 17.1665 9.04167 17.1667H22.5833ZM9.58333
            7.41675H11.75V9.58341H9.58333V7.41675ZM9.58333 10.6667H11.75V12.8334H9.58333V10.6667ZM9.58333
            13.9167H11.75V16.0834H9.58333V13.9167Z"
            fill="currentColor"/>
        </SvgIcon>
    )
}

export const DocumentsIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.75 3.75V8.75C18.75 9.08152 18.8817 9.39946 19.1161 9.63388C19.3505 9.8683 19.6685 10 20
                10H25" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                <path d="M22.5 21.25H13.75C13.087 21.25 12.4511 20.9866 11.9822 20.5178C11.5134 20.0489 11.25 19.413
                11.25 18.75V6.25C11.25 5.58696 11.5134 4.95107 11.9822 4.48223C12.4511 4.01339 13.087 3.75 13.75
                3.75H18.75L25 10V18.75C25 19.413 24.7366 20.0489 24.2678 20.5178C23.7989 20.9866 23.163 21.25 22.5 21.25Z"
                      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                <path d="M20 21.25V23.75C20 24.413 19.7366 25.0489 19.2678 25.5178C18.7989 25.9866 18.163 26.25 17.5
                26.25H8.75C8.08696 26.25 7.45107 25.9866 6.98223 25.5178C6.51339 25.0489 6.25 24.413 6.25
                23.75V11.25C6.25 10.587 6.51339 9.95107 6.98223 9.48223C7.45107 9.01339 8.08696 8.75 8.75 8.75H11.25"
                      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        </SvgIcon>
    )
}

export const DocumentsRetentionIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.08333 12.5833H4V6.08659C4 5.48642 4.49292 5 5.07467 5H24.592C24.7342 4.9997 24.8751 5.02769
                25.0064 5.08234C25.1377 5.13699 25.2568 5.2172 25.3568 5.31832C25.4568 5.41944 25.5357 5.53943 25.5889
                5.67133C25.6421 5.80322 25.6685 5.94438 25.6667 6.08659V12.5833H24.5833V23.4178C24.5838 23.5594 24.5563
                23.6998 24.5024 23.8309C24.4486 23.962 24.3695 24.0812 24.2696 24.1817C24.1697 24.2822 24.051 24.362
                23.9203 24.4166C23.7895 24.4712 23.6493 24.4996 23.5076 24.5H6.15908C6.01739 24.4996 5.87716 24.4712
                5.74641 24.4166C5.61567 24.362 5.49696 24.2822 5.39707 24.1817C5.29717 24.0812 5.21805 23.962 5.16422
                23.8309C5.11039 23.6998 5.08291 23.5594 5.08333 23.4178V12.5833ZM22.4167
                12.5833H7.25V22.3333H22.4167V12.5833ZM6.16667 7.16667V10.4167H23.5V7.16667H6.16667ZM11.5833
                14.75H18.0833V16.9167H11.5833V14.75Z" fill="currentColor"/>
        </SvgIcon>
    )
}

export const HL7DashboardIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.75 8.5L11.75 13.5L19.25 21L24.25 1L1.75 9.75L6.75 12.25L9.25 19.75L13 14.75"
                  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        </SvgIcon>
    )
}

export const PatientMergesIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 14C16.3261 14 17.5979 14.5268 18.5355 15.4645C19.4732 16.4021 20 17.6739 20 19V25H18V19C18
            18.2348 17.7077 17.4985 17.1827 16.9417C16.6578 16.385 15.9399 16.0499 15.176 16.005L15 16C14.2348 16 13.4985
            16.2923 12.9417 16.8173C12.385 17.3422 12.0499 18.0601 12.005 18.824L12 19V25H10V19C10 17.6739 10.5268
            16.4021 11.4645 15.4645C12.4021 14.5268 13.6739 14 15 14ZM8.5 17C8.779 17 9.05 17.033 9.31 17.094C9.13902
            17.603 9.03777 18.1328 9.009 18.669L9 19V19.086C8.88505 19.0449 8.76549 19.018 8.644 19.006L8.5 19C8.12712
            19 7.76761 19.1389 7.49158 19.3896C7.21555 19.6403 7.0428 19.9848 7.007 20.356L7 20.5V25H5V20.5C5 19.5717
            5.36875 18.6815 6.02513 18.0251C6.6815 17.3687 7.57174 17 8.5 17V17ZM21.5 17C22.4283 17 23.3185 17.3687
            23.9749 18.0251C24.6313 18.6815 25 19.5717 25 20.5V25H23V20.5C23 20.1271 22.8611 19.7676 22.6104 19.4916C22.3597
            19.2156 22.0152 19.0428 21.644 19.007L21.5 19C21.325 19 21.157 19.03 21 19.085V19C21 18.334 20.892 17.694
            20.691 17.096C20.95 17.033 21.221 17 21.5 17ZM8.5 11C9.16304 11 9.79893 11.2634 10.2678 11.7322C10.7366
            12.2011 11 12.837 11 13.5C11 14.163 10.7366 14.7989 10.2678 15.2678C9.79893 15.7366 9.16304 16 8.5 16C7.83696
            16 7.20107 15.7366 6.73223 15.2678C6.26339 14.7989 6 14.163 6 13.5C6 12.837 6.26339 12.2011 6.73223
            11.7322C7.20107 11.2634 7.83696 11 8.5 11V11ZM21.5 11C22.163 11 22.7989 11.2634 23.2678 11.7322C23.7366
            12.2011 24 12.837 24 13.5C24 14.163 23.7366 14.7989 23.2678 15.2678C22.7989 15.7366 22.163 16 21.5 16C20.837
            16 20.2011 15.7366 19.7322 15.2678C19.2634 14.7989 19 14.163 19 13.5C19 12.837 19.2634 12.2011 19.7322
            11.7322C20.2011 11.2634 20.837 11 21.5 11V11ZM8.5 13C8.36739 13 8.24021 13.0527 8.14645 13.1464C8.05268
            13.2402 8 13.3674 8 13.5C8 13.6326 8.05268 13.7598 8.14645 13.8536C8.24021 13.9473 8.36739 14 8.5 14C8.63261
            14 8.75979 13.9473 8.85355 13.8536C8.94732 13.7598 9 13.6326 9 13.5C9 13.3674 8.94732 13.2402 8.85355
            13.1464C8.75979 13.0527 8.63261 13 8.5 13ZM21.5 13C21.3674 13 21.2402 13.0527 21.1464 13.1464C21.0527 13.2402
            21 13.3674 21 13.5C21 13.6326 21.0527 13.7598 21.1464 13.8536C21.2402 13.9473 21.3674 14 21.5 14C21.6326
            14 21.7598 13.9473 21.8536 13.8536C21.9473 13.7598 22 13.6326 22 13.5C22 13.3674 21.9473 13.2402 21.8536
            13.1464C21.7598 13.0527 21.6326 13 21.5 13ZM15 5C16.0609 5 17.0783 5.42143 17.8284 6.17157C18.5786 6.92172
            19 7.93913 19 9C19 10.0609 18.5786 11.0783 17.8284 11.8284C17.0783 12.5786 16.0609 13 15 13C13.9391 13 12.9217
            12.5786 12.1716 11.8284C11.4214 11.0783 11 10.0609 11 9C11 7.93913 11.4214 6.92172 12.1716 6.17157C12.9217
            5.42143 13.9391 5 15 5V5ZM15 7C14.4696 7 13.9609 7.21071 13.5858 7.58579C13.2107 7.96086 13 8.46957 13 9C13
            9.53043 13.2107 10.0391 13.5858 10.4142C13.9609 10.7893 14.4696 11 15 11C15.5304 11 16.0391 10.7893 16.4142
            10.4142C16.7893 10.0391 17 9.53043 17 9C17 8.46957 16.7893 7.96086 16.4142 7.58579C16.0391 7.21071 15.5304 7
            15 7V7Z" fill="currentColor"/>
        </SvgIcon>
    )
}

export const PinAdministrationIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.4167 11.7499C20.4167 11.1955 20.2051 10.641 19.7821 10.2179C19.359 9.79487 18.8045 9.58333
            18.25 9.58333M18.25 18.25C21.8399 18.25 24.75 15.3399 24.75 11.75C24.75 8.16015 21.8399 5.25 18.25
            5.25C14.6601 5.25 11.75 8.16015 11.75 11.75C11.75 12.0465 11.7699 12.3383 11.8083 12.6243C11.8715 13.0946
            11.9031 13.3298 11.8819 13.4786C11.8597 13.6335 11.8315 13.7171 11.7551 13.8537C11.6817 13.9849 11.5525
            14.1141 11.2941 14.3726L5.75768 19.909C5.57032 20.0964 5.47664 20.19 5.40964 20.2994C5.35024 20.3963 5.30647
            20.502 5.27993 20.6125C5.25 20.7372 5.25 20.8697 5.25 21.1346V23.0167C5.25 23.6234 5.25 23.9268 5.36808
            24.1585C5.47194 24.3623 5.63767 24.5281 5.84151 24.6319C6.07325 24.75 6.37661 24.75 6.98333
            24.75H9.58333V22.5833H11.75V20.4167H13.9167L15.6274 18.7059C15.8859 18.4475 16.0151 18.3183 16.1463
            18.2449C16.2829 18.1685 16.3665 18.1403 16.5214 18.1181C16.6702 18.0969 16.9054 18.1285 17.3757 18.1917C17.6617
            18.2302 17.9535 18.25 18.25 18.25Z"
            stroke="currentColor" strokeWidth="2.16667" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        </SvgIcon>

    )
}

export const AdminDashboardIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M24 6C24.2652 6 24.5196 6.10536 24.7071 6.29289C24.8946 6.48043 25 6.73478 25
                7V23C25 23.2652 24.8946 23.5196 24.7071 23.7071C24.5196 23.8946 24.2652 24 24 24H6C5.73478
                24 5.48043 23.8946 5.29289 23.7071C5.10536 23.5196 5 23.2652 5 23V7C5 6.73478 5.10536 6.48043
                5.29289 6.29289C5.48043 6.10536 5.73478 6 6 6H24ZM14 16H7V22H14V16ZM23 16H16V22H23V16ZM14
                8H7V14H14V8ZM23 8H16V14H23V8Z" fill="currentColor"/>
        </SvgIcon>

    )
}

export const UserAuditIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 30 30" fill="none">
            <path d="M5.25 4.16675H22.5887C23.7826 4.16675 24.75 5.13958 24.75 6.32258V23.6776C24.75 24.8682 23.7826 25.8334
            22.5887 25.8334H5.25V4.16675ZM9.58333 6.33341H7.41667V23.6667H9.58333V6.33341ZM11.75
            23.6667H22.5833V6.33341H11.75V23.6667ZM13.9167 19.3334C13.9167 18.4715 14.2591 17.6448 14.8686
            17.0353C15.4781 16.4258 16.3047 16.0834 17.1667 16.0834C18.0286 16.0834 18.8553 16.4258 19.4648
            17.0353C20.0743 17.6448 20.4167 18.4715 20.4167 19.3334H13.9167ZM17.1667 15.0001C16.592 15.0001 16.0409
            14.7718 15.6346 14.3655C15.2283 13.9591 15 13.408 15 12.8334C15 12.2588 15.2283 11.7077 15.6346 11.3014C16.0409
            10.895 16.592 10.6667 17.1667 10.6667C17.7413 10.6667 18.2924 10.895 18.6987 11.3014C19.1051 11.7077 19.3333
            12.2588 19.3333 12.8334C19.3333 13.408 19.1051 13.9591 18.6987 14.3655C18.2924 14.7718 17.7413 15.0001 17.1667
            15.0001ZM25.8333 8.50008H28V12.8334H25.8333V8.50008ZM25.8333 15.0001H28V19.3334H25.8333V15.0001Z" fill="currentColor"/>
        </SvgIcon>
    )
}

export const UpsertDataIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 30 30" fill="none">
            <path d="M24.75 10.6667V24.7424C24.751 24.8847 24.724 25.0258 24.6704 25.1576C24.6169 25.2894 24.538 25.4094
            24.4381 25.5107C24.3382 25.612 24.2193 25.6926 24.0883 25.748C23.9572 25.8034 23.8165 25.8324 23.6743
            25.8334H6.32575C6.04063 25.8334 5.76717 25.7202 5.56546 25.5187C5.36375 25.3171 5.25029 25.0438 5.25
            24.7587V5.24135C5.25 4.6596 5.73642 4.16669 6.3355 4.16669H18.2467L24.75 10.6667ZM22.5833
            11.75H17.1667V6.33335H7.41667V23.6667H22.5833V11.75ZM10.6667 9.58335H13.9167V11.75H10.6667V9.58335ZM10.6667
            13.9167H19.3333V16.0834H10.6667V13.9167ZM10.6667 18.25H19.3333V20.4167H10.6667V18.25Z" fill="currentColor"/>
        </SvgIcon>
    )
}

export const DocumentStatisticIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 30 30" fill="none">
            <path d="M16.8333 4.29199V8.76674C16.8333 9.37347 16.8333 9.67683 16.9514 9.90857C17.0553 10.1124 17.221
            10.2781 17.4248 10.382C17.6566 10.5001 17.9599 10.5001 18.5667 10.5001H23.0414M10.3333 18.0833V21.3333M19
            15.9167V21.3333M14.6667 13.2083V21.3333M23.3333 12.6539V20.4667C23.3333 22.2868 23.3333 23.1969 22.9791
            23.8921C22.6675 24.5037 22.1703 25.0008 21.5588 25.3124C20.8636 25.6667 19.9535 25.6667 18.1333
            25.6667H11.2C9.37983 25.6667 8.46974 25.6667 7.77453 25.3124C7.163 25.0008 6.66582 24.5037 6.35423
            23.8921C6 23.1969 6 22.2868 6 20.4667V9.2C6 7.37983 6 6.46974 6.35423 5.77453C6.66582 5.163 7.163 4.66582
            7.77453 4.35423C8.46974 4 9.37983 4 11.2 4H14.6794C15.4743 4 15.8718 4 16.2458 4.0898C16.5775 4.16941 16.8945
            4.30073 17.1853 4.47892C17.5132 4.67991 17.7943 4.96095 18.3564 5.52304L21.8103 8.97695C22.3724 9.53905
            22.6534 9.82009 22.8544 10.1481C23.0326 10.4389 23.1639 10.7559 23.2435 11.0875C23.3333 11.4615 23.3333
            11.859 23.3333 12.6539Z" stroke="currentColor" strokeWidth="2.16667" strokeLinecap="round"
            strokeLinejoin="round" fill="none"/>
        </SvgIcon>
    )
}

export const EnvelopLockIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 30 30" fill="none">
            <path d="M20 7.238L12.072 14.338L4 7.216V19H13V21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536
            20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652
            3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V11H20V7.238ZM19.501 5H4.511L12.061
            11.662L19.502 5H19.501ZM22 17H23V22H15V17H16V16C16 15.2044 16.3161 14.4413 16.8787 13.8787C17.4413 13.3161
            18.2044 13 19 13C19.7956 13 20.5587 13.3161 21.1213 13.8787C21.6839 14.4413 22 15.2044 22 16V17ZM20 17V16C20
            15.7348 19.8946 15.4804 19.7071 15.2929C19.5196 15.1054 19.2652 15 19 15C18.7348 15 18.4804 15.1054 18.2929
            15.2929C18.1054 15.4804 18 15.7348 18 16V17H20Z" fill="currentColor"/>
        </SvgIcon>
    )
}

export const EnvelopOpenIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 30 30" fill="none">
            <path d="M2.243 6.85399L11.49 1.30999C11.6454 1.21674 11.8233 1.16748 12.0045 1.16748C12.1857 1.16748 12.3636
            1.21674 12.519 1.30999L21.757 6.85499C21.8311 6.8994 21.8925 6.96227 21.9351 7.03746C21.9776 7.11264 22
            7.19758 22 7.28399V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478
            21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V7.28299C1.99998 7.19658 2.02236 7.11164
            2.06495 7.03646C2.10753 6.96127 2.16888 6.8984 2.243 6.85399ZM4 8.13299V19H20V8.13199L12.004 3.33199L4
            8.13199V8.13299ZM12.06 13.698L17.356 9.23499L18.644 10.765L12.074 16.302L5.364 10.772L6.636 9.22799L12.06
            13.698Z" fill="currentColor"/>
        </SvgIcon>
    )
}

export const UploadIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="-2 0 30 24" fill="none">
            <path d="M15 4H5V20H19V8H15V4ZM3 2.992C3 2.444 3.447 2 3.999 2H16L21 7V20.993C21.0009 21.1243 20.976 21.2545
            20.9266 21.3762C20.8772 21.4979 20.8043 21.6087 20.7121 21.7022C20.6199 21.7957 20.5101 21.8701 20.3892
            21.9212C20.2682 21.9723 20.1383 21.9991 20.007 22H3.993C3.73038 21.9982 3.47902 21.8931 3.29322 21.7075C3.10742
            21.5219 3.00209 21.2706 3 21.008V2.992ZM13 12V16H11V12H8L12 8L16 12H13Z" fill="currentColor"/>
        </SvgIcon>
    )
}

export const DownloadIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="-5 -5 26 30" fill="none">
            <path d="M8 0C8.55228 0 9 0.447715 9 1V11.5858L11.2929 9.29289C11.6834 8.90237 12.3166 8.90237 12.7071
            9.29289C13.0976 9.68342 13.0976 10.3166 12.7071 10.7071L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976
            7.29289 14.7071L3.29289 10.7071C2.90237 10.3166 2.90237 9.68342 3.29289 9.29289C3.68342 8.90237 4.31658
            8.90237 4.70711 9.29289L7 11.5858V1C7 0.447715 7.44772 0 8 0ZM1 15C1.55228 15 2 15.4477 2 16V18H14V16C14
            15.4477 14.4477 15 15 15C15.5523 15 16 15.4477 16 16V18C16 19.1046 15.1046 20 14 20H2C0.895431 20 0 19.1046
            0 18V16C0 15.4477 0.447715 15 1 15Z" fill="currentColor"/>
        </SvgIcon>
    )
}

export const PlusIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="-2 -2 28 28" fill="none">
            <path d="M12 4C12.5523 4 13 4.44772 13 5V11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19
            13H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V13H5C4.44772 13 4 12.5523 4 12C4 11.4477
            4.44772 11 5 11H11V5C11 4.44772 11.4477 4 12 4Z" fill="currentColor"/>
        </SvgIcon>
    )
}

export const DbSlicesIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="-1 -1 26 26" fill="none">
            <path d="M5 6.5C5 6.52553 5.01022 6.66958 5.29209 6.91948C5.57279 7.16834 6.03602 7.43815 6.69427 7.68499C8.0034
            8.17591 9.87903 8.5 12 8.5C14.121 8.5 15.9966 8.17591 17.3057 7.68499C17.964 7.43815 18.4272 7.16834 18.7079
            6.91948C18.9898 6.66958 19 6.52553 19 6.5C19 6.47447 18.9898 6.33042 18.7079 6.08052C18.4272 5.83166 17.964
            5.56185 17.3057 5.31501C15.9966 4.82409 14.121 4.5 12 4.5C9.87903 4.5 8.0034 4.82409 6.69427 5.31501C6.03602
            5.56185 5.57279 5.83166 5.29209 6.08052C5.01022 6.33042 5 6.47447 5 6.5ZM3 6.5C3 5.69711 3.43749 5.05194 3.96527
            4.58401C4.49422 4.11504 5.20256 3.7384 5.99202 3.44235C7.57833 2.84749 9.70269 2.5 12 2.5C14.2973 2.5 16.4217
            2.84749 18.008 3.44235C18.7974 3.7384 19.5058 4.11504 20.0347 4.58401C20.5625 5.05194 21 5.69711 21
            6.5V10.5V14.5V18.5C21 19.3029 20.5625 19.9481 20.0347 20.416C19.5058 20.885 18.7974 21.2616 18.008 21.5576C16.4217
            22.1525 14.2973 22.5 12 22.5C9.70269 22.5 7.57833 22.1525 5.99202 21.5576C5.20256 21.2616 4.49422 20.885 3.96527
            20.416C3.43749 19.9481 3 19.3029 3 18.5V14.5V10.5V6.5ZM5 10.5C5 10.5255 5.01022 10.6696 5.29209 10.9195C5.57279
            11.1683 6.03602 11.4381 6.69427 11.685C8.0034 12.1759 9.87903 12.5 12 12.5C14.121 12.5 15.9966 12.1759 17.3057
            11.685C17.964 11.4381 18.4272 11.1683 18.7079 10.9195C18.9898 10.6696 19 10.5255 19 10.5V9.11619C18.6909 9.27981
            18.3574 9.42662 18.008 9.55765C16.4217 10.1525 14.2973 10.5 12 10.5C9.70269 10.5 7.57833 10.1525 5.99202
            9.55765C5.64262 9.42662 5.3091 9.27981 5 9.11619V10.5ZM5 13.1162V14.5C5 14.5255 5.01022 14.6696 5.29209
            14.9195C5.57279 15.1683 6.03602 15.4381 6.69427 15.685C8.0034 16.1759 9.87903 16.5 12 16.5C14.121 16.5 15.9966
            16.1759 17.3057 15.685C17.964 15.4381 18.4272 15.1683 18.7079 14.9195C18.9898 14.6696 19 14.5255 19
            14.5V13.1162C18.6909 13.2798 18.3574 13.4266 18.008 13.5576C16.4217 14.1525 14.2973 14.5 12 14.5C9.70269 14.5
            7.57833 14.1525 5.99202 13.5576C5.64262 13.4266 5.3091 13.2798 5 13.1162ZM5 17.1162V18.5C5 18.5255 5.01022
            18.6696 5.29209 18.9195C5.57279 19.1683 6.03602 19.4381 6.69427 19.685C8.0034 20.1759 9.87903 20.5 12 20.5C14.121
            20.5 15.9966 20.1759 17.3057 19.685C17.964 19.4381 18.4272 19.1683 18.7079 18.9195C18.9898 18.6696 19 18.5255
            19 18.5V17.1162C18.6909 17.2798 18.3574 17.4266 18.008 17.5576C16.4217 18.1525 14.2973 18.5 12 18.5C9.70269
            18.5 7.57833 18.1525 5.99202 17.5576C5.64262 17.4266 5.3091 17.2798 5 17.1162Z" fill="currentColor"/>
        </SvgIcon>
    )
}

export const ErrorIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 16 13" fill="none">
            <path d="M8.57756 0.56247L14.9282 11.9062C14.9867 12.0107 15.0175 12.1293 15.0175 12.25C15.0175 12.3706
            14.9867 12.4892 14.9282 12.5937C14.8697 12.6982 14.7856 12.785 14.6842 12.8454C14.5829 12.9057 14.4679 12.9375
            14.3509 12.9375H1.64956C1.53254 12.9375 1.41758 12.9057 1.31623 12.8454C1.21489 12.785 1.13073 12.6982 1.07222
            12.5937C1.01371 12.4892 0.982909 12.3706 0.98291 12.25C0.982911 12.1293 1.01372 12.0107 1.07223 11.9062L7.42289
            0.56247C7.48141 0.457965 7.56557 0.371184 7.66691 0.310849C7.76825 0.250514 7.88321 0.21875 8.00023 0.21875C8.11725
            0.21875 8.2322 0.250514 8.33355 0.310849C8.43489 0.371184 8.51905 0.457965 8.57756 0.56247V0.56247ZM7.33356
            9.49997V10.875H8.66689V9.49997H7.33356ZM7.33356 4.68747V8.12497H8.66689V4.68747H7.33356Z"
            fill="currentColor"/>
        </SvgIcon>
    )
}

export const CopyIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 22 22" fill="none">
            <path d="M7 7V4.2C7 3.0799 7 2.51984 7.21799 2.09202C7.40973 1.71569 7.71569 1.40973 8.09202 1.21799C8.51984
            1 9.07989 1 10.2 1H17.8C18.9201 1 19.4802 1 19.908 1.21799C20.2843 1.40973 20.5903 1.71569 20.782 2.09202C21
            2.51984 21 3.0799 21 4.2V11.8C21 12.9201 21 13.4802 20.782 13.908C20.5903 14.2843 20.2843 14.5903 19.908
            14.782C19.4802 15 18.9201 15 17.8 15H15M4.2 21H11.8C12.9201 21 13.4802 21 13.908 20.782C14.2843 20.5903
            14.5903 20.2843 14.782 19.908C15 19.4802 15 18.9201 15 17.8V10.2C15 9.07989 15 8.51984 14.782 8.09202C14.5903
            7.71569 14.2843 7.40973 13.908 7.21799C13.4802 7 12.9201 7 11.8 7H4.2C3.0799 7 2.51984 7 2.09202 7.21799C1.71569
            7.40973 1.40973 7.71569 1.21799 8.09202C1 8.51984 1 9.07989 1 10.2V17.8C1 18.9201 1 19.4802 1.21799 19.908C1.40973
            20.2843 1.71569 20.5903 2.09202 20.782C2.51984 21 3.07989 21 4.2 21Z" stroke="currentColor" strokeWidth="2"
            strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        </SvgIcon>
    )
}

export const SendIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="-3 -4 28 28" fill="none">
            <path d="M0.945838 7.31504C0.423838 7.14104 0.418838 6.86004 0.955838 6.68104L20.0428 0.31904C20.5718 0.14304
            20.8748 0.43904 20.7268 0.95704L15.2728 20.043C15.1228 20.572 14.8178 20.59 14.5938 20.088L10.9998 12L16.9998
            4.00004L8.99984 10L0.945838 7.31504Z" fill="currentColor"/>
        </SvgIcon>
    )
}

export const EditPencilIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="-3 -2 24 24" fill="none">
            <path d="M13.2929 0.292893C13.6834 -0.0976311 14.3166 -0.0976311 14.7071 0.292893L18.7071 4.29289C19.0976
            4.68342 19.0976 5.31658 18.7071 5.70711L5.70711 18.7071C5.51957 18.8946 5.26522 19 5 19H1C0.447715 19 0
            18.5523 0 18V14C0 13.7348 0.105357 13.4804 0.292893 13.2929L10.2927 3.2931L13.2929 0.292893ZM11 5.41421L2
            14.4142V17H4.58579L13.5858 8L11 5.41421ZM15 6.58579L16.5858 5L14 2.41421L12.4142 4L15 6.58579Z" fill="currentColor"/>
        </SvgIcon>
    )
}

export const TrashBinIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="-2 -2 24 24" fill="none">
            <path d="M5 2C5 0.89543 5.89543 0 7 0H13C14.1046 0 15 0.895431 15 2V4H16.9897C16.9959 3.99994 17.0021 3.99994
            17.0083 4H19C19.5523 4 20 4.44772 20 5C20 5.55228 19.5523 6 19 6H17.9311L17.0638 18.1425C16.989 19.1891 16.1182
            20 15.0689 20H4.93112C3.88184 20 3.01096 19.1891 2.9362 18.1425L2.06888 6H1C0.447715 6 0 5.55228 0 5C0 4.44772
            0.447715 4 1 4H2.99174C2.99795 3.99994 3.00414 3.99994 3.01032 4H5V2ZM7 4H13V2H7V4ZM4.07398 6L4.93112
            18H15.0689L15.926 6H4.07398Z" fill="currentColor"/>
        </SvgIcon>
    )
}

export const UploadIcon2 = (props) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24" fill="none">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362
                20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854
                3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 8L12 3M12 3L7 8M12 3V15"
                      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </SvgIcon>
    )
}

export const AttachmentIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 19 23" fill="none">
            <svg width="19" height="23" viewBox="0 0 19 23" fill="none">
                <path d="M4 9.5V4C4 3.17157 4.67157 2.5 5.5 2.5C6.32843 2.5 7 3.17157 7 4V9.5C7 11.1569 5.65685
                12.5 4 12.5C2.34315 12.5 1 11.1569 1 9.5V5.5M10.5 1.5H13.2C14.8802 1.5 15.7202 1.5 16.362 1.82698C16.9265
                2.1146 17.3854 2.57354 17.673 3.13803C18 3.77976 18 4.61984 18 6.3V16.7C18 18.3802 18 19.2202 17.673
                19.862C17.3854 20.4265 16.9265 20.8854 16.362 21.173C15.7202 21.5 14.8802 21.5 13.2 21.5H6.8C5.11984
                21.5 4.27976 21.5 3.63803 21.173C3.07354 20.8854 2.6146 20.4265 2.32698 19.862C2 19.2202 2 18.3802 2
                16.7V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </SvgIcon>
    )
}


export const MergeRecordIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 19 23" fill="none">
            <svg width="18" height="18" viewBox="2 2 20 20" stroke="currentColor" strokeWidth="1"
                 strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_86_5928)">
                    <path d="M6.00008 21C5.2916 21.0011 4.60561 20.7513 4.06361 20.2951C3.52161 19.8388 3.15857 19.2055
                    3.03879 18.5072C2.91902 17.8089 3.05024 17.0908 3.40921 16.48C3.76819 15.8692 4.33175 15.4051 5.00008
                    15.17V8.83C4.33259 8.59409 3.76999 8.1298 3.41172 7.51919C3.05346 6.90858 2.92259 6.19098 3.04227
                    5.49321C3.16195 4.79545 3.52445 4.16246 4.06571 3.70613C4.60697 3.2498 5.29213 2.99951 6.00008
                    2.99951C6.70803 2.99951 7.39319 3.2498 7.93445 3.70613C8.47571 4.16246 8.83822 4.79545 8.95789
                    5.49321C9.07757 6.19098 8.94671 6.90858 8.58844 7.51919C8.23018 8.1298 7.66757 8.59409 7.00008
                    8.83V9C7.00008 9.53043 7.21079 10.0391 7.58587 10.4142C7.96094 10.7893 8.46965 11 9.00008
                    11H15.0001C16.0609 11 17.0784 11.4214 17.8285 12.1716C18.5787 12.9217 19.0001 13.9391 19.0001
                    15V15.17C19.6676 15.4059 20.2302 15.8702 20.5884 16.4808C20.9467 17.0914 21.0776 17.809 20.9579
                    18.5068C20.8382 19.2046 20.4757 19.8375 19.9345 20.2939C19.3932 20.7502 18.708 21.0005 18.0001
                    21.0005C17.2921 21.0005 16.607 20.7502 16.0657 20.2939C15.5245 19.8375 15.1619 19.2046 15.0423
                    18.5068C14.9226 17.809 15.0535 17.0914 15.4117 16.4808C15.77 15.8702 16.3326 15.4059 17.0001
                    15.17V15C17.0001 14.4696 16.7894 13.9609 16.4143 13.5858C16.0392 13.2107 15.5305 13 15.0001
                    13H9.00008C8.2979 13.0011 7.60792 12.8166 7.00008 12.465V15.171C7.66652 15.4076 8.22798 15.8721
                    8.58541 16.4823C8.94283 17.0925 9.07326 17.8094 8.95368 18.5064C8.8341 19.2035 8.4722 19.8359
                    7.93181 20.2921C7.39143 20.7483 6.70729 20.999 6.00008 21Z"
                          stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
                </g>
                <defs>
                    <clipPath id="clip0_86_5928">
                        <rect width="24" height="24" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
                    </clipPath>
                </defs>
            </svg>
        </SvgIcon>
    )
}